<app-guest>
  <form *ngIf="step=='form'" [formGroup]="form" (ngSubmit)="onSubmit()">
    <h2 class="fw-bold fs-5 text-center mb-3">Password reset</h2>
    <div class="mb-3">
      <label for="password" class="form-label fw-bold">Enter a new password</label>
      <div class="input-group mb-3">
        <input [type]="showPassword ? 'text' : 'password'" class="form-control" id="password" formControlName="password" placeholder="8 characters min + capital letter + number">
        <span (click)="showPassword = !showPassword" class="input-group-text" role="button">
          <i [class.bi-eye]="showPassword" [class.bi-eye-slash]="!showPassword" class="bi"></i>
        </span>
      </div>
    </div>
    <div *ngIf="form.get('password')?.touched && form.get('password')?.errors as errors" class="text-danger my-3">
      <div *ngIf="errors['minLength']">
        Password must be at least {{ errors['minLength'].requiredLength }} characters long (currently {{ errors['minLength'].actualLength }}).
      </div>
      <div *ngIf="errors['uppercase']">
        Password must contain at least one capital letter.
      </div>
      <div *ngIf="errors['number']">
        The password must contain at least one number.
      </div>
    </div>
    <div class="mb-3">
      <label for="passwordConfirm" class="form-label fw-bold">Confirm your new password</label>
      <div class="input-group mb-3">
        <input [type]="showPasswordConfirm ? 'text' : 'password'" class="form-control" id="passwordConfirm" formControlName="passwordConfirm">
        <span (click)="showPasswordConfirm = !showPasswordConfirm" class="input-group-text" role="button">
          <i [class.bi-eye]="showPasswordConfirm" [class.bi-eye-slash]="!showPasswordConfirm" class="bi"></i>
        </span>
      </div>
    </div>
    <div class="d-grid mb-3">
      <button type="submit" class="btn btn-primary fw-bold p-lg-3" [disabled]="form.invalid">Change password</button>
    </div>
    <div class="text-center small">Already have an account? <a routerLink="/login">Sign in</a></div>
  </form>

  <div *ngIf="step=='invalid-key'" class="card-body text-center">
    <i class="bi bi-check-circle-fill text-success display-4"></i>
    <h1 class="fw-bold fs-5 mt-3">The link is either invalid or has expired.</h1>
    <p class="text-muted">Please try resetting your password again.</p>
    <a routerLink="/password-lost" class="btn btn-primary fw-bold p-lg-3">Return to password lost</a>
  </div>

  <div *ngIf="step=='success'" class="card-body text-center">
    <i class="bi bi-check-circle-fill text-success display-4"></i>
    <h1 class="fw-bold fs-5 mt-3">Your password has been changed successfully.</h1>
    <p class="text-muted">You can now return to the login page.</p>
    <a routerLink="/login" class="btn btn-primary fw-bold p-lg-3">Return to sign in</a>
  </div>
</app-guest>
